import { Button, Radio, Dialog, DialogHeader, DialogBody } from "@material-tailwind/react";
import { addNewCompanyFeeApi, updateCompanyCompanyFeeApi } from "api/companyFees";
import { getAllOperatorsApi } from "api/filtersData";
import { getAllCompanyFeeCityApi } from "api/companyFeesCities";
import NewCityModale from "./New_city_modale";
import API_URL from "config";
import React, { useEffect, useState } from "react";
import { getCookie } from "utils/cookies";

import { MdPictureAsPdf, MdAddLocationAlt } from "react-icons/md";

function DYNAMICModale({ closePopup, actionType, selectedData, selectedCategory, showToast, accessList }) {
  const [listOfTcp, setListOfTcp] = useState([]);
  const [companyFeesCities, setCompanyFeesCities] = useState([]);
  const [showNewCityForm, setShowNewCityForm] = useState(false);

  const [formInputValue, setFormInputValue] = useState({
    feesSubCategory: "",
    date: "",
    responsable: "",
    montant: "",
    description: "",
    isJustify: "true",

    vehicule: "",
    typeOfOp: "DYNAMIC",
    feesCategory: selectedCategory?._id || "",
    fromCity: "",
    toCity: "",
  });

  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    getFilterData();
  }, []);

  useEffect(() => {
    getFormData()
  }, [selectedData])

  useEffect(() => {
    setFormInputValue((prev) => ({
      ...prev,
      feesCategory: selectedCategory?._id || "",
    }));
  }, [selectedCategory]);

  const urlToFile = async (url) => {
    try {
      // Fetch the file from the URL
      const response = await fetch(url);
      const blob = await response.blob();

      // Extract file name from URL
      const fileName = url.substring(url.lastIndexOf("/") + 1);

      // Create a new File object
      const file = new File([blob], fileName, {
        type: blob.type,
        lastModified: new Date().getTime(),
      });

      return file;
    } catch (error) {
      console.error("Error converting URL to file:", error);
      return null;
    }
  };

  const getFormData = async () => {
    if (actionType !== "new") {
      try {
        setFormInputValue({
          feesSubCategory: selectedData.feesSubCategory || "",
          date: selectedData?.date && !isNaN(new Date(selectedData.date)) ? selectedData?.date : "",
          responsable: selectedData?.responsable._id,
          montant: selectedData.montant || "",
          description: selectedData.description || "",
          isJustify: selectedData.isJustify ? "true" : "false",

          vehicule: selectedData?.responsable?.UserVehicul,
          typeOfOp: "DYNAMIC",
          feesCategory: selectedData?.feesCategory?._id || selectedData?.feesCategory || "",
          fromCity: selectedData?.fromCity?._id || "",
          toCity: selectedData?.toCity?._id || "",
        });

        const selectedFile = selectedData?.bonFile
        ? `${API_URL}/${selectedData?.bonFile}`
        : null;

        if(selectedFile) {
          urlToFile(selectedFile).then((file) => {
            // console.log('Converted File:', file);
            setFile(file);

            // Preview the file
            const reader = new FileReader();
            reader.onloadend = () => {
              setPreview(reader.result);
            };
            reader.readAsDataURL(file);
          });
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const getFilterData = async () => {
    try {
      const response = await getAllOperatorsApi();

      if (accessList?.administrations) {
        setListOfTcp(response);
      } else {
        const loggedInID = getCookie("3F2Mb2pJ1YRro5Z4");
        const selfOnly = response.filter((el) => el._id === loggedInID);
        setListOfTcp(selfOnly);

        if (actionType === "new" && selfOnly.length > 0) {
          setFormInputValue((prevFormInputValue) => ({
            ...prevFormInputValue,
            responsable: selfOnly[0]._id,
            vehicule: selfOnly[0].UserVehicul,
          }));
        }
      }
    } catch (err) {
      console.log(err);
    }

    try {
      const cities = await getAllCompanyFeeCityApi();
      setCompanyFeesCities(cities);
    } catch (err) {
      console.log(err);
    }
  };

  const handleNewCityModale = () => {
    setShowNewCityForm(!showNewCityForm);
    getFilterData();
  };

  const handleFiltersInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "responsable") {
      const selectedOperator = listOfTcp.find((el) => el._id == value);
      setFormInputValue({
        ...formInputValue,
        responsable: value,
        vehicule: selectedOperator?.UserVehicul || "",
      });
      return;
    }

    setFormInputValue({
      ...formInputValue,
      [name]: value,
    });
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);

    // Preview the file
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
    };
    reader.readAsDataURL(selectedFile);
  };

  const handleOpImageClick = () => {
    document.getElementById("op_image").click();
  };

  const handleAddNewFees = async () => {
    try {
      if(new Date(formInputValue.date).getFullYear().toString().length > 4)
        return showToast("error", "Date invalide");

      await addNewCompanyFeeApi(formInputValue, file)
      showToast("success", "Ajoutée");
    } catch (err) {
      showToast("error", err?.response?.data?.error);
    }
  };

  const handleUpdateFees = async () => {
    try {
      await updateCompanyCompanyFeeApi(formInputValue, file, selectedData._id)
      showToast("success", "Modifiée");
    }
    catch (err) {
      showToast("error", err?.response?.data?.error);
    }
  }

  const handleCancelOp = () => {
    closePopup("Close");
  };

  return (
    <div className="max-h-[80vh] overflow-y-auto">
      <Dialog size="xl" open={showNewCityForm} handler={handleNewCityModale}>
        <DialogHeader>
          <p className="w-full text-center">Nouveau point</p>
        </DialogHeader>
        <DialogBody>
          <NewCityModale closePopup={handleNewCityModale} />
        </DialogBody>
      </Dialog>

      <div className="mt-2 grid grid-cols-1 gap-5 md:grid-cols-2">
        <div>
          <div>
            <label htmlFor="" className="text-md font-bold text-navy-700">
              Sous-catégorie :
            </label>
            <select
              label="select Version"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="feesSubCategory"
              value={formInputValue.feesSubCategory}
              onChange={handleFiltersInputChange}
              disabled={actionType === "show"}
            >
              <option value=""></option>
              {(selectedCategory?.subCategories || []).map((el) => (
                <option key={el._id} value={el._id}>
                  {el.name}
                </option>
              ))}
            </select>
          </div>
          <div className="mt-4">
            <label htmlFor="" className="text-md font-bold text-navy-700">
              Date :
            </label>
            <input
              type="date"
              id=""
              placeholder="Date"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="date"
              value={
                actionType === "new"
                ? formInputValue.date
                : formInputValue.date.split("T")[0]
              }
              onChange={handleFiltersInputChange}
            />
          </div>
          <div className="mt-4">
            <label htmlFor="" className="text-md font-bold text-navy-700">
              Responsable :
            </label>
            <select
              label="select Version"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="responsable"
              value={formInputValue.responsable}
              onChange={handleFiltersInputChange}
              disabled={actionType === "show"}
            >
              <option value=""></option>
              {listOfTcp.map((el) => (
                <option key={el._id} value={el._id}>{el.Name}</option>
              ))}
            </select>
          </div>
          <div className="mt-4">
            <label htmlFor="" className="text-md font-bold text-navy-700">
              Véhicule :
            </label>
            <input
              type="text"
              id=""
              placeholder="aucun"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              disabled
              value={formInputValue.vehicule}
            />
          </div>
          <div className="mt-4">
            <label htmlFor="" className="text-md font-bold text-navy-700">
              Montant :
            </label>
            <input
              type="number"
              id=""
              placeholder=""
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="montant"
              value={formInputValue.montant}
              onChange={handleFiltersInputChange}
              disabled={actionType === "show"}
            />
          </div>

          {selectedCategory?.requiresStartEndPoint && (
            <>
              <div className="mt-4 flex items-center justify-center">
                <div className="w-[90%]">
                  <label htmlFor="" className="text-md font-bold text-navy-700">
                    Point de départ :
                  </label>
                  <select
                    label="select Version"
                    className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
                    name="fromCity"
                    value={formInputValue.fromCity}
                    onChange={handleFiltersInputChange}
                    disabled={actionType === "show"}
                  >
                    <option value=""></option>
                    {companyFeesCities.map((el) => (
                      <option key={el._id} value={el._id}>{el.Name}</option>
                    ))}
                  </select>
                </div>
                <div className="w-[10%]">
                  <MdAddLocationAlt
                    size={40}
                    color="#236571"
                    className="cursor-pointer"
                    onClick={handleNewCityModale}
                  />
                </div>
              </div>
              <div className="mt-4">
                <label htmlFor="" className="text-md font-bold text-navy-700">
                  Point d'arrivée :
                </label>
                <select
                  label="select Version"
                  className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
                  name="toCity"
                  value={formInputValue.toCity}
                  onChange={handleFiltersInputChange}
                  disabled={actionType === "show"}
                >
                  <option value=""></option>
                  {companyFeesCities.map((el) => (
                    <option key={el._id} value={el._id}>{el.Name}</option>
                  ))}
                </select>
              </div>
            </>
          )}
        </div>

        <div>
          <div>
            <label htmlFor="" className="text-md font-bold text-navy-700">
              Description :
            </label>

            <textarea
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              rows={5}
              name="description"
              value={formInputValue.description}
              onChange={handleFiltersInputChange}
              disabled={actionType === "show"}
            ></textarea>
          </div>
          <div className="mt-4">
            <label
              htmlFor=""
              className="text-md font-bold text-navy-700"
            ></label>
            <div className="flex gap-10">
              <Radio
                name="isJustify"
                value={true}
                onChange={handleFiltersInputChange}
                label="Justifier"
                checked={formInputValue.isJustify === "true"}
                disabled={actionType === "show"}
              />
              <Radio
                name="isJustify"
                value={false}
                onChange={handleFiltersInputChange}
                label="Non justifier"
                checked={formInputValue.isJustify === "false"}
                disabled={actionType === "show"}
              />
            </div>
          </div>
          <div className="mt-4">
            <input
              type="file"
              id="op_image"
              style={{ display: "none" }}
              onChange={handleFileChange}
              accept="image/*, .pdf, .doc, .docx, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            />
            {!preview && (
              <label
                htmlFor="op_image"
                style={{ cursor: "pointer" }}
                className="text-grey-500 rounded-full border-0 bg-blue-50 py-2 px-6 text-sm font-medium text-blue-700 hover:cursor-pointer hover:bg-amber-50 hover:text-amber-700"
              >
                Clicker ici pour sélectionner votre document
              </label>
            )}
            {preview && (
              <div>
                {/* Display the file preview: image/ - application/pdf */}
                {file.type.startsWith("image/") ? (
                  <img
                    src={preview}
                    alt="File Preview"
                    onClick={handleOpImageClick}
                    style={{
                      maxWidth: "120px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "10px",
                      cursor: "pointer",
                    }}
                  />
                ) : (
                  <div>
                    <MdPictureAsPdf
                      onClick={handleOpImageClick}
                      style={{ cursor: "pointer" }}
                      size={100}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="mt-5">
        {
          actionType == "new" &&
            <Button
              variant="gradient"
              color="#236571"
              onClick={() => handleAddNewFees()}
              className="mr-1"
            >
              <span>Ajouter</span>
            </Button>
        }
        {
          actionType == "update" &&
            <Button
              variant="gradient"
              color="#236571"
              onClick={() => handleUpdateFees()}
              className="mr-1"
            >
              <span>Modifier</span>
            </Button>
        }
        <Button
          variant="text"
          color="#cf503f"
          onClick={() => handleCancelOp()}
          className="mr-1"
        >
          <span>Annuler</span>
        </Button>
      </div>
    </div>
  );
}

export default DYNAMICModale;
